import React from 'react';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import { Modal } from 'react-bootstrap';

const Cookie = {
  /**
   * @param { string } name 
   */
  get: function(name, option = {}){ return ""; },
  
  /**
   * @param { string } name
   */
  set: function(name, value, option = {}){ },

  /**
   * @param { string } name 
   */
  remove: function(name, option = {}){ },
};

class CookieService extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  constructor(props){
    super(props);

    console.log("init cookies");

    Cookie.get = function(name, option = {}){ 
      return props.cookies.get(name, option); 
    }

    Cookie.set = function(name, value, option = {}){ 
      props.cookies.set(name, value, option);
    }

    Cookie.remove = function(name, option = {}){
      props.cookies.remove(name, option); 
    }
  }

  render(){
    return (
      <Modal>
        { this.props.children }
      </Modal>
    );
  }
}

const CookieComponent = withCookies(CookieService);
export { Cookie, CookieComponent };